import { SavedSearchModel, SavedSearchResponse } from 'app/gamma/src/types';
import genericNormalizer from './generic';

export const normalizeSavedSearch = genericNormalizer<
  SavedSearchResponse,
  SavedSearchModel
>(({ from }) => ({
  id: from('id'),
  name: from('name'),
  pos: from('pos'),
  query: from('query'),
}));
